<template>
  <v-navigation-drawer
    v-model="menu"
    right
    app
  >
    <v-toolbar
      flat
      class="transparent"
    >
      <v-list>
        <v-list-tile avatar>
          <v-list-tile-avatar>
            <img :src="profileImage" alt="">
          </v-list-tile-avatar>

          <v-list-tile-content>
            <v-list-tile-title>
              {{user.tenant ? user.tenant : $t('labels.notLoggedIn')}}
            </v-list-tile-title>
            <v-list-tile-sub-title v-if="account.isAdmin && user.pchn">
              {{$t('labels.loggedInAs')}}: {{user.pchn}}
            </v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-toolbar>

    <v-list>
      <v-divider></v-divider>

      <v-list-tile
        to="/dashboard"
        :disabled="signingOut"
      >
        <v-list-tile-action>
          <v-icon>fa-columns</v-icon>
        </v-list-tile-action>

        <v-list-tile-content>
          <v-list-tile-title v-t="'menu.overview'"></v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile
        to="/profiel"
        :disabled="signingOut"
      >
        <v-list-tile-action>
          <v-icon>fa-user-circle</v-icon>
        </v-list-tile-action>

        <v-list-tile-content>
          <v-list-tile-title v-t="'menu.myInfo'"></v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile to="/geschiedenis">
        <v-list-tile-action>
          <v-icon>fa-chart-line</v-icon>
        </v-list-tile-action>

        <v-list-tile-content>
          <v-list-tile-title v-t="'menu.history'"></v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile
        @click="signOut"
        :disabled="signingOut"
      >
        <v-list-tile-action>
          <v-icon>fa-power-off</v-icon>
        </v-list-tile-action>

        <v-list-tile-content>
          <v-list-tile-title v-t="'menu.logout'"></v-list-tile-title>
        </v-list-tile-content>
        <v-list-tile-action v-show="signingOut">
          <v-icon>fa-spin fa-spinner</v-icon>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  props: ['value'],

  data() {
    return {
      menu: this.value,
      signingOut: false,
    };
  },

  watch: {
    menu(value) {
      this.$emit('input', value);
    },

    value(value) {
      this.menu = value;
    },
  },

  computed: {
    account() { return this.$store.state.account; },

    user() { return this.$store.state.profile.user; },

    profileImage() { return this.user.streetViewUrl; },

    isAuthenticating() { return this.$store.state.account.isAuthenticating; },
  },

  methods: {
    async signOut() {
      this.signingOut = true;

      const { userToken } = this.$store.state.account;

      if (userToken) {
        await this.$store.dispatch('account/signOutAs');
      } else {
        await this.$store.dispatch('account/signOut');
      }

      this.signingOut = false;
      this.menu = false;

      if (userToken) {
        this.$router.push('/inloggen/als');
      } else {
        this.$router.push('/inloggen');
      }
    },
  },
};
</script>

<style lang="scss">
</style>
